<template>
  <v-container fluid>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"

      absolute
    >
      <v-btn
        text
        @click="snackbar = false"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      {{ message }}
    </v-snackbar>

    <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
      <v-card

        max-width="100%"
      >

        <v-card-title v-if="canBeGenerated()" class="accent--text" style="font-size: 14px; font-weight:700;"> CREATE COMMUNAL RATE LIMIT</v-card-title>
        <v-card-title  v-if="canApproveConversion()" class="accent--text" style="font-size: 14px; font-weight:700;"> APPROVE COMMUNAL RATE LIMIT</v-card-title>
        <!--                <v-divider class="mx-4"></v-divider>-->

        <div >
          <v-card-text>

            <v-form ref="editform" v-model="valid" lazy-validation no-gutters justify="space-around">
              <v-row no-gutters justify="space-around">
                <v-col cols="12" sm="12"
                  class="d-flex justify-start "
                >
                  <div class="warrant_box">

                    <v-layout>
                        <v-autocomplete
                          name="organisationName"
                          v-model="organization.organisationName"
                          :items="organizations"
                          item-text="organisationName"
                          item-value='organisationName'
                          @input="updateOrganization"
                          label="Select Organization"
                        >
                        </v-autocomplete>
                    </v-layout>
                  </div>
                </v-col>
              </v-row>
              <v-row
                     no-gutters justify="space-around"
                     v-if=" canBeGenerated() && Object.keys(communalCycleInfo).length > 0   "
              >
                <v-col
                  class="d-flex justify-start"
                >

                  <v-text-field  type="text" label="Season" v-model="communalCycleInfo.season" @change="updatePaymentCycle"></v-text-field>

                </v-col>


                <v-col
                  class="d-flex justify-end"
                >
<!--                  <v-btn color="primary" @click="setConversionRate(dealcode)">Submit</v-btn>-->
                </v-col>

              </v-row>
              <v-row
                v-if="canBeGenerated() && Object.keys(communalCycleInfo).length > 0    "
              >
                <v-col cols="3" >
                  <span class="" >PAYMENT CYCLE : </span>
                  <span><b>{{communalCycleInfo.cycle}}</b></span>
                </v-col>
                <v-col cols="6" >
                  <span class="" >COMPUTED COMMUNAL RATE : </span>
                  <span><b> {{communalCycleInfo.rate}}</b></span>
                </v-col>

              </v-row>
              <br>
              <v-row
                no-gutters justify="space-around"
                v-if="canBeGenerated() && Object.keys(communalCycleInfo).length > 0 "
              >
                <v-col
                  class="d-flex justify-start"
                >

                  <v-text-field  type="number" label="Communal Minimum Rate" v-model="communalRateLimit"></v-text-field>

                </v-col>
                <v-col>
                  <v-checkbox
                    v-model="lastPayment"
                    :label="'Last Payment'"
                    dense
                    hide-details
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </v-col>

                <v-col
                  class="d-flex justify-end"
                >
                  <v-btn color="primary" @click="setMinimumCommunalLimit">Submit</v-btn>
                </v-col>

              </v-row>

            </v-form>

          </v-card-text>

          <v-divider   v-if="Object.keys(communalCycleInfo).length > 0   " ></v-divider>
        </div>
        <div v-if="Object.keys(communalCycleInfo).length > 0">
        <v-card-title class="accent--text" style="font-size: 12px; font-weight:600;"> Communal Rates</v-card-title>
        <v-card-text>

          <table class="table">
            <thead class="thead">
            <tr>
              <th scope="col">Organization</th>
              <th scope="col">Season</th>
              <th scope="col">Cycle</th>
              <th scope="col">Limit</th>
              <th scope="col">Maker</th>
              <th scope="col">Checker</th>
              <th scope="col">Status</th>
              <th scope="col">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="history in filteredList" v-bind:key="history.id">
              <td> {{ history.fcs !== null ? history.fcs.organisationName : '' }}</td>
              <td> {{ history.season }}</td>
              <td> {{ history.cycle }}</td>
              <td> {{ history.communalRateLimit }}</td>
              <td> {{ history.limitSetBy }}</td>
              <td> {{ history.limitApprovedBy }}</td>
              <td>{{ history.status?.statusName }}</td>
              <td class="actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      class="actions"
                    >
                      <v-icon class="secondary--text"> more_horiz</v-icon>
                    </v-btn>
                  </template>
                  <v-list v-if="canBeApproved(history)">
                    <v-list-item  @click="showConfirmDialog (history,'APPROVE')">
                      <v-list-item-title> Approve</v-list-item-title>
                    </v-list-item>
                    <v-list-item  @click="showConfirmDialog (history,'REJECT')">
                      <v-list-item-title> Reject</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
            </tbody>
          </table>
        </v-card-text>

        <v-card-actions>
          <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
          <v-spacer></v-spacer>
          <v-pagination
            v-model="page"
            :length="numberOfLinks"
            color="secondary"
                class="accent--text logoutbtn"
          ></v-pagination>
        </v-card-actions>
        </div>
      </v-card>
    </div>
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="body-2 primary--text font-weight-bold text-capitalize">{{ this.action }} Conversion Rate
        </v-card-title>

        <v-card-text class="primary--text">
          {{ confirmMessage }}
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="confirmDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="accent--text logoutbtn"
            @click="approveRecord"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import themes from 'devextreme/ui/themes'

export default {
	name: 'ccarfUsdKesRate',
	data: function () {
		return {
      loggedinOrgId: '',
      lastPayment: false,
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			history: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			editDialog: false,
			confirmDialog: false,
			permissions: [],
			dealcode: 0,
			organizations: [],
      communalRateLimit:'',
      communalCycleInfo:{},
			organization: {
				id: '',
				organisationName: '',
        organisationCode: ''
			},
			disableFarmer: {},
			confirmMessage: '',
			fcsCode: '',
			cherry: 0.00,
			debt: 0.00,
			limit: 0.00,
			action: '',
			isFcs: ' '
		}
	},
	mounted () {
    this.getLoggedInUser()
		this.getOrganizations()

		this.permissions = store.state.user.roleId.permissions
		this.isFcs = store.state.user.organisation.organisationType.name === 'FARMER_SOCIETY'
		this.fcsCode = store.state.user?.organisation?.organisationCode
	},
	watch: {

		history () {
			this.paginatedFiles = this.paginationMethod(this.history, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.history.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.history, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.history.filter(hist => {
					return (hist.fcs.organisationName !== null ? hist.fcs.organisationName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (hist.season === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : hist.season.toLowerCase().includes(this.search.toLowerCase())) || hist.status.statusName.toLowerCase().includes(this.search.toLowerCase()) || hist.communalRateLimit.includes(this.search)
				})
			}
		}
	},
	methods: {
		paginationMethod (items, pageNumber, limitPerPage) {
			console.log("items ",items)
      console.log("ddd",Array.isArray(items))
      pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		ifFCS () {
			return this.isFcs
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
    getLoggedInUser () {
      this.theUser = JSON.parse(localStorage.getItem('user'))
      console.log('user ===>> ', this.theUser)
      this.loggedinOrgId = this.theUser.organisation.id
      // this.curUserN = this.curUser.firstName
    },
		getCommunalRates () {
      this.history= [];
			const url = config.serverURI + '/payment/fetchCommunalRateLimits/' + this.organization.id;
			axios.get(url)
				.then(response => {
					this.history = response.data.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		getOrganizations () {
			const url = config.serverURI + '/organization/getAll'
			axios.get(url)
				.then(response => {
					console.log('org response', response.data)
					this.organizations = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		updateOrganization () {
			const selectedOrganization = this.organizations.find(organization => organization.organisationName === this.organization?.organisationName)
			if (selectedOrganization) {
				console.log('Organization  Id>>>', selectedOrganization.id)
				console.log('Organization  Name>>>', selectedOrganization.organisationName)
        console.log('Organization  Code>>>', selectedOrganization.organisationCode)
				this.organization.organisationName = selectedOrganization.organisationName
				this.organization.id = selectedOrganization.id
        this.organization.organisationCode = selectedOrganization.organisationCode
        this.fetchFCSCommunalCycleInfo()
        this.getCommunalRates()
			}
		},

    fetchFCSCommunalCycleInfo () {
      const url = config.serverURI + '/payment/fetchFCSLimitInfo'
      axios.post(url, {
        growerCode: this.organization.organisationCode
      })
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.communalCycleInfo = response.data.data
          console.log('communalCycleInfo', this.communalCycleInfo)
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },

		setConversionRate () {
			const url = config.serverURI + '/payment/conversionRate/update'
			axios.post(url, {
				rateCode: this.dealcode
			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.getCommunalRates()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},

    updatePaymentCycle () {
      const url = config.serverURI + '/payment/computeCycle'
      axios.post(url, {
        growerCode: this.organization.organisationCode,
        season: this.communalCycleInfo.season
      })
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
          if(response.data.data){
            this.communalCycleInfo.cycle = response.data.data.cycle
            this.communalCycleInfo.rate = response.data.data.rate
          }
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },

    setMinimumCommunalLimit () {
      const url = config.serverURI + '/payment/setCommunalRateLimit'
      axios.post(url, {
        growerCode: this.organization.organisationCode,
        limit: this.communalRateLimit,
        season: this.communalCycleInfo.season,
        paymentCycle: this.communalCycleInfo.cycle,
        lastPayment: String(this.lastPayment)
      })
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.getCommunalRates()
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = 'Error occurred while processing your request'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
		canBeApproved (item) {
			return item.status.id === 3 && this.hasPerm('CAN_APPROVE_COMMUNAL_RATE')

		},
		canBeGenerated () {
      // return true
			return this.hasPerm('CAN_SET_COMMUNAL_RATE')
		},
    canApproveConversion () {
      // return true
      return this.hasPerm('CAN_APPROVE_COMMUNAL_RATE')
    },
		showConfirmDialog (item, action) {
			this.confirmDialog = true
			this.item = item
			this.action = action
			if (action === 'APPROVE') {
				this.confirmMessage = 'Do you want to Approve the  selected Communal Rate Limit (' + item?.communalRateLimit + ') ?'
			} else if (action === 'REJECT') {
				this.confirmMessage = 'Do you want to the  selected Communal Rate Limit (' + item?.communalRateLimit + ') ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},
		approveRecord () {
			const url = config.serverURI + '/payment/approveCommunalRate/' + this.loggedinOrgId
			axios.post(url, {
        limitId: this.item?.id,
				action: this.action

			})
				.then(response => {
					if (response.data.error !== false) {
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
						console.log('Error is ' + this.message)
						this.confirmDialog = false
						this.getCommunalRates()
						return
					}
					this.message = response.data.message
					this.snackbar = true
					this.snackbarColor = 'primary'
					this.confirmDialog = false
					this.getCommunalRates()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred while processing your request'
					this.snackbar = true
					this.snackbarColor = 'error'
					this.confirmDialog = false
					this.getCommunalRates()
				})
		}

	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

</style>
